export const borne = (min: number, target: number, max: number) => {
    return Math.min(max, Math.max(min, target));
}

// Check if a point is inside or on the ellipse
const isInsideEllipse = (x: number, y: number, centerX: number, centerY: number, a: number, b: number) => {
    const dx = x - centerX;
    const dy = y - centerY;
    return (dx * dx) / (a * a) + (dy * dy) / (b * b) <= 1;
}

// Find the closest point on or inside the ellipse to a target point
export const closestPointOnEllipse = (targetX: number, targetY: number, centerX: number, centerY: number, a: number, b: number) => {
    // If target is inside ellipse, return it as-is
    if (isInsideEllipse(targetX, targetY, centerX, centerY, a, b)) {
        return { x: targetX, y: targetY };
    }

    // Find closest point on ellipse boundary using parametric approach
    // Ellipse parametric: x = centerX + a*cos(t), y = centerY + b*sin(t)
    // We iterate to find the angle that gives us the closest point

    let bestAngle = Math.atan2((targetY - centerY) / b, (targetX - centerX) / a);
    let bestDist = Infinity;
    let bestX = 0, bestY = 0;

    // Refine the angle using a simple iterative search
    for (let iteration = 0; iteration < 3; iteration++) {
        const searchRange = Math.PI / (2 ** iteration);
        const step = searchRange / 10;

        for (let offset = -searchRange; offset <= searchRange; offset += step) {
            const angle = bestAngle + offset;
            const x = centerX + a * Math.cos(angle);
            const y = centerY + b * Math.sin(angle);
            const dist = (x - targetX) ** 2 + (y - targetY) ** 2;

            if (dist < bestDist) {
                bestDist = dist;
                bestX = x;
                bestY = y;
                bestAngle = angle;
            }
        }
    }

    return { x: bestX, y: bestY };
}